import { NavLink } from "react-router-dom";
import { SquaresFour, Package, Truck, Camera, List } from "@phosphor-icons/react";

const ITEMS = [
  { to: "/dashboard", label: "Home", icon: SquaresFour, testid: "bottom-nav-dashboard" },
  { to: "/inventory", label: "Stock", icon: Package, testid: "bottom-nav-inventory" },
  { to: "/shipping", label: "Freight", icon: Truck, testid: "bottom-nav-shipping" },
  { to: "/live-feed", label: "Feed", icon: Camera, testid: "bottom-nav-live-feed" },
];

export const MobileTabBar = ({ onMenu }) => (
  <nav
    data-testid="mobile-tab-bar"
    className="fixed bottom-0 left-0 right-0 z-40 flex border-t border-border bg-white/95 pb-[env(safe-area-inset-bottom)] backdrop-blur lg:hidden"
  >
    {ITEMS.map(({ to, label, icon: Icon, testid }) => (
      <NavLink
        key={to}
        to={to}
        data-testid={testid}
        className={({ isActive }) =>
          `flex min-h-[56px] flex-1 flex-col items-center justify-center gap-0.5 text-[0.65rem] font-semibold uppercase tracking-wide transition-colors duration-150 ${
            isActive ? "text-[#002FA7]" : "text-slate-500"
          }`
        }
      >
        <Icon size={20} />
        {label}
      </NavLink>
    ))}
    <button
      type="button"
      data-testid="bottom-nav-menu"
      onClick={onMenu}
      className="flex min-h-[56px] flex-1 flex-col items-center justify-center gap-0.5 text-[0.65rem] font-semibold uppercase tracking-wide text-slate-500"
    >
      <List size={20} />
      Menu
    </button>
  </nav>
);
